module.exports = __webpack_public_path__ + "img/game-place.26f3659e.png";